import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconImages41: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconImages41"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM7 13C7 15.2091 8.79086 17 11 17H13C15.2091 17 17 15.2091 17 13H15.7725C14.1051 13 12.6118 14.0345 12.0264 15.5957L12 15.666L11.9736 15.5957C11.3882 14.0344 9.89503 12.9999 8.22754 13H7ZM13.25 8L12 7L10.75 8L9.5 7V9.75C9.5 11.1307 10.6193 12.25 12 12.25C13.3807 12.25 14.5 11.1307 14.5 9.75V7L13.25 8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconImages41;
